import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "slotDetailsContainer"
}
const _hoisted_2 = { class: "detailsHeader" }
const _hoisted_3 = { class: "headerLeft" }
const _hoisted_4 = { class: "detailsContent" }
const _hoisted_5 = { class: "infoSection" }
const _hoisted_6 = { class: "infoItem" }
const _hoisted_7 = { class: "infoValue" }
const _hoisted_8 = {
  key: 0,
  class: "infoItem"
}
const _hoisted_9 = { class: "infoValue" }
const _hoisted_10 = { class: "doctorsSection" }
const _hoisted_11 = {
  key: 0,
  class: "loadingState"
}
const _hoisted_12 = { class: "doctorName" }
const _hoisted_13 = {
  key: 0,
  class: "overlapWarning"
}
const _hoisted_14 = { class: "profileSelector" }
const _hoisted_15 = { class: "actionsSection" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_ctx.selectedSlot)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              icon: "",
              size: "small",
              variant: "text",
              onClick: _ctx.closeDetails,
              class: "mr-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-arrow-left", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "detailsTitle" }, "Appointment Details", -1))
          ]),
          _createVNode(_component_v_btn, {
            icon: "",
            size: "small",
            variant: "text",
            onClick: _ctx.closeDetails
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "infoLabel" }, "Date & Time:", -1)),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedSlot?.datetime), 1)
            ]),
            (_ctx.selectedPatient)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "infoLabel" }, "Patient:", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.selectedPatient?.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "sectionTitle" }, "Doctors & Profiles", -1)),
            (_ctx.isLoadingLastAppointment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "24",
                    width: "2"
                  }),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ml-2" }, "Loading last appointment...", -1))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors, (doctor) => {
              return (_openBlock(), _createElementBlock("div", {
                key: doctor.externalId,
                class: "doctorItem"
              }, [
                _createElementVNode("div", {
                  class: "doctorHeader",
                  style: _normalizeStyle({ borderLeftColor: doctor.color })
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(doctor.name), 1)
                ], 4),
                (doctor.isOverlap)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_v_icon, {
                        size: "small",
                        color: "warning",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode("mdi-alert", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[7] || (_cache[7] = _createElementVNode("span", null, "This doctor has another appointment at this time (overlap allowed)", -1))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "profileLabel" }, "Appointment Profile (optional):", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedProfiles[doctor.externalId],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.selectedProfiles[doctor.externalId]) = $event),
                    items: _ctx.allProfiles,
                    "item-title": "name",
                    "item-value": "id",
                    "return-object": "",
                    density: "compact",
                    variant: "outlined",
                    placeholder: "No profile (optional)",
                    clearable: "",
                    "hide-details": "",
                    class: "profileSelect"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_v_btn, {
              color: "primary",
              size: "large",
              variant: "flat",
              block: "",
              disabled: !_ctx.canSave,
              loading: _ctx.isSaving,
              onClick: _ctx.saveAppointment
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("mdi-calendar-check", -1)
                  ]))]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createTextVNode(" Book Appointment ", -1))
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}